/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Box, Text, Tooltip } from '@chakra-ui/react';
import React, { useEffect } from 'react';

const Q_SALE_STAFF = gql`
	query get($id: String!) {
		getCompanySaleProfessionalById(id: $id) {
			id
			idCardNumber
			firstName
			lastName
			firstNameEn
			lastNameEn
		}
	}
`;

export default function EventLoggingSaleProfessional({ id = null }) {
	const [fetchData, { data }] = useLazyQuery(Q_SALE_STAFF);

	useEffect(() => {
		id && fetchData({ variables: { id } });
	}, [id]);

	return (
		<>
			{data?.getCompanySaleProfessionalById?.id && (
				<Tooltip
					label={
						<Box>
							{data?.getCompanySaleProfessionalById?.idCardNumber && (
								<Text color="white" fontWeight="semibold">
									{data?.getCompanySaleProfessionalById?.idCardNumber}
								</Text>
							)}
							{(data?.getCompanySaleProfessionalById?.firstName || data?.getCompanySaleProfessionalById?.lastName) && (
								<Text color="white" fontWeight="normal">
									{data?.getCompanySaleProfessionalById?.firstName + ' ' + data?.getCompanySaleProfessionalById?.lastName}
								</Text>
							)}
							{(data?.getCompanySaleProfessionalById?.firstNameEn || data?.getCompanySaleProfessionalById?.lastNameEn) && (
								<Text color="white" fontWeight="normal">
									{data?.getCompanySaleProfessionalById?.firstNameEn + ' ' + data?.getCompanySaleProfessionalById?.lastNameEn}
								</Text>
							)}
						</Box>
					}
				>
					<Text cursor="pointer" fontSize="sm" fontWeight="semibold" color="gray.500">
						{data?.getCompanySaleProfessionalById?.idCardNumber}
					</Text>
				</Tooltip>
			)}
		</>
	);
}
